import { configureStore } from '@reduxjs/toolkit'
//import taskReducer from './TaskSlice'
import studentReducer from './StudentSlice'
import teacherReducer from './TeacherSlice'
import answerSetReducer from './AnswerSetSlice'
import frontPageReducer from './FrontPageSlice'


const store = configureStore({
    reducer: {
        studentData: studentReducer,
        teacherData: teacherReducer,
        answerSet: answerSetReducer,
        frontPageData: frontPageReducer,
        // taskData: taskReducer,
    },
})


export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch